export default {
    title: "Ihr genehmigender Manager ist {email}"
}